import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useCallback, useEffect, useState } from "react";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import ADIColors from "@NA/Utils/ADIColors";
import TextField from "@insite/mobius/TextField";
import { cloneDeep } from "lodash";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
// Eco fee and Special handling implementation ----P21 Change
import ADIEcoFeeDisplay from "../ADIEcoFeeDisplay";
import ADISpecialHandlingFeeDisplay from "../ADISpecialHandlingFeeDisplay";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

interface OwnProps {
    quoteDetails?: OrderModel;
    disablingAcceptCheckout: () => void;
    isAcceptCheckoutDisable: boolean;
    setQtyItems: Function;
    qtyItems: any;
    setNewQuoteDetails: Function;
    setIsAcceptCheckoutDisable: Function;
}

type Props = OwnProps;

export interface AdiRfqQuoteDetailsOrderLinesListStyles {
    inputFieldStyles?: InjectableCss;
    desktopQtyField?: InjectableCss;
    orderDetailsHeader?: InjectableCss;
    orderDetailsItemsText?: InjectableCss;
    orderDetailsAvailableQtyText?: InjectableCss;
    orderDetailsQtyText?: InjectableCss;
    orderDetailsUnitPriceText?: InjectableCss;
    orderDetailsExtPriceText?: InjectableCss;
    orderDetailsContainer?: InjectableCss;
    orderLineCardGridContainer?: InjectableCss;
    orderLineCardImageDescription?: InjectableCss;
    productImageLink?: LinkPresentationProps;
    productImageLinkMobile?: LinkPresentationProps;
    orderLineCardImage?: LazyImageProps;
    orderLineCardImageMobile?: LazyImageProps;
    productDescriptionStylesMobile?: InjectableCss;
    imgTextStyles?: InjectableCss;
    imgTextStylesMobile?: InjectableCss;
    orderLineCardImageDescriptionMobile?: InjectableCss;
    orderLineCardInfoMobile?: InjectableCss;
    manufacturerItemStyles?: InjectableCss;
    qtyFieldContainer?: InjectableCss;
    qtyFieldContainerAvailable?: InjectableCss;
    unitPriceContainer?: InjectableCss;
    extPriceContainer?: InjectableCss;
    manufacturerItemMobileStyles?: InjectableCss;
    extPriceMobileStyles?: InjectableCss;
    unitPriceMobileStyles?: InjectableCss;
    qtyMobileStyles?: InjectableCss;
    manufacturerItemContainerMobileStyles?: InjectableCss;
    descriptionHeaderRight?: InjectableCss;
    longDescriptionStyles?: TypographyProps;
    longDescriptionMobileStyles?: TypographyProps;
    totalPrint?: TypographyProps;
    availableQtyFieldMobile?: InjectableCss;
    ecoFeeContainer?: InjectableCss;
    ecoFeeContainerStyle?: InjectableCss;
    ecofeeGridContainer?: ADIECOFeeExtendedStyles;
    specialHandlingfeeGridContainer?: ADISpecialHandlingFeeExtendedStyles;
}

export interface ADIECOFeeExtendedStyles{
    ecofeeGridContainer?:InjectableCss
}

export const ADIECOFeeExtendedStyles = {
    ecofeeGridContainer: {
        css: css`
        padding: 0px !important
        `
    }
}

export interface ADISpecialHandlingFeeExtendedStyles{
    specialHandlingfeeGridContainer?: InjectableCss
};

export const ADISpecialHandlingFeeExtendedStyles = {
    specialHandlingfeeGridContainer: {
        css: css`
         padding: 0px !important;
         ${({ theme }) => { return breakpointMediaQueries(
            theme, [css`justify-content: flex-start;`,],); 
        }}
        `
    }
}



export const adiRfqQuoteDetailsOrderLinesListStyles: AdiRfqQuoteDetailsOrderLinesListStyles = {
    inputFieldStyles: {
        css: css`
            width: 100%;
            .error-qty-msg {
                margin: 0 auto;
                width: 105px;
                display: flex;
                font-size: 14px;
                line-height: 1.14;
                color: ${ADIColors.black};
                font-weight: bold;
                flex-direction: row;
                justify-content: center;
                align-items: flex-start;
                text-align: left;
                @media only screen and (max-width: 767px) {
                    width: 100%;
                    padding-top: 8px;
                }
                img {
                    width: 12px;
                    height: 12px;
                    min-width: 12px;
                    object-fit: contain;
                    margin: 1px 6px 0px 0;
                }
            }
            > ${FormFieldStyle} {
                > ${FormInputWrapper} {
                    margin-top: 0px !important;
                    input {
                        width: 54px;
                        height: 40px;
                        margin: 0px auto 2px auto;
                        padding: 7px 10px;
                        border-radius: 4px;
                        border: solid 1px ${ADIColors.gray3};
                        background-color: ${getColor("common.background")};
                        text-align: center;
                        color: ${getColor("text.main")};
                        font-weight: 800;
                        line-height: 1.43;
                        font-size: 14px;
                        &:focus {
                            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                            border-color: ${ADIColors.gray3};
                            background-color: ${getColor("common.background")};
                        }
                        @media print {
                            border: none;
                            padding: 0;
                            height: auto;
                            width: 100%;
                        }
                    }
                }
            }
        `,
    },
    availableQtyFieldMobile: {
        css: css`
            text-align: left;
            display: block;
            width: 100%;
            height: auto;
            padding: 0px;
            padding-top: 6px;
            margin: 0px;
            font-size: 14px;
            font-weight: bold;
            color: ${getColor("text.main")};
            @media print {
                display: none;
            }
        `,
    },
    longDescriptionMobileStyles: {
        css: css`
            line-height: 1.22;
            width: 90%;
            margin: 0 0 5px 0;
            @media print {
                display: none;
                color: ${ADIColors.black};
            }
        `,
    },
    desktopQtyField: {
        css: css`
            display: block;
            font-weight: normal;
            color: ${getColor("text.main")};
            line-height: 1.43;
            font-size: 14px;
        `,
    },
    totalPrint: {
        css: css`
            display: none;
            @media print {
                display: block;
                color: ${ADIColors.black};
                font-size: 14px;
                margin-top: 15px;
                font-weight: bold;
            }
        `,
    },
    longDescriptionStyles: {
        css: css`
            line-height: 1.22;
            width: 90%;
            margin: 0 0 5px 0;
        `,
    },
    orderDetailsHeader: {
        css: css`
            width: 100%;
            padding: 14px 0 13px 0;
            display: flex;
            border-bottom: solid 1px ${getColor("common.border")};
            justify-content: space-between;
            align-items: center;
            color: ${getColor("text.main")};
            font-size: 16px;
            font-weight: bold;
            line-height: 1.13;
            margin-top: 5px;
            margin-bottom: 10px;
            @media screen and (min-width: 576px) and (max-width: 1024px) {
                padding: 11px 5px 11px 5px;
                background-color: ${ADIColors.white2};
            }
            @media only screen and (max-width: 576px) {
                display: none;
            }
        `,
    },
    orderDetailsItemsText: {
        css: css`
            width: 57.7%;
        `,
    },
    orderDetailsAvailableQtyText: {
        css: css`
            width: 13.2%;
            text-align: center;
        `,
    },
    orderDetailsQtyText: {
        css: css`
            width: 13.2%;
            text-align: center;
        `,
    },
    orderDetailsUnitPriceText: {
        css: css`
            width: 13.2%;
            text-align: right;
        `,
    },
    orderDetailsExtPriceText: {
        css: css`
            width: 15.9%;
            text-align: right;
        `,
    },
    orderDetailsContainer: {
        css: css`
            width: 100%;
        `,
    },
    orderLineCardGridContainer: {
        css: css`
            width: 100%;
            display: flex;
            border-bottom: solid 1px ${ADIColors.gray7};
            padding: 16px 0 16px 0;
            justify-content: space-between;
            flex-wrap: wrap;
            &:first-child {
                padding: 16px 0 16px 0;
            }
            &:last-child {
                @media only screen and (max-width: 767px) {
                    margin-bottom: 0px;
                }
            }
            @media only screen and (max-width: 767px) {
                border: 1px solid ${ADIColors.gray7};
                margin-bottom: 25px;
            }
        `,
    },
    descriptionHeaderRight: {
        css: css`
            display: flex;
            flex-direction: column;
            width: calc(100% - 78px);
            padding-left: 28px;
            > ${StyledButton} {
                width: 90%;
                margin: 0px 0px 5px 0px;
                &:hover {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
                > ${TypographyStyle} {
                    font-size: 16px;
                    color: ${getColor("text.main")} !important;
                    font-weight: 600;
                    line-height: 22px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    &:hover {
                        color: ${getColor("text.main")} !important;
                        text-decoration: underline;
                    }
                    @media print {
                        text-overflow: unset;
                    }
                }
            }
        `,
    },
    manufacturerItemContainerMobileStyles: {
        css: css`
            @media print {
                display: none;
            }
            @media only screen and (max-width: 767px) {
                margin-top: 14px;
                text-align: center;
            }
        `,
    },
    productDescriptionStylesMobile: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
    qtyMobileStyles: {
        css: css`
            font-size: 14px;
            width: 100%;
            @media print {
                display: none;
            }
        `,
    },
    unitPriceMobileStyles: {
        css: css`
            font-size: 12px;
            margin-top: 1px;
            @media print {
                display: none;
            }
        `,
    },
    extPriceMobileStyles: {
        css: css`
            margin-top: 5px;
            font-weight: bold;
            @media print {
                display: none;
            }
            @media only screen and (max-width: 767px) {
                font-size: 20px;
                font-weight: 900;
                line-height: normal;
                padding-bottom: 6px;
            }
        `,
    },
    manufacturerItemMobileStyles: {
        css: css`
            font-size: 10px;
            color: ${ADIColors.gray4};
            @media print {
                display: none;
            }
        `,
    },
    qtyFieldContainerAvailable: {
        css: css`
            width: 5%;
            text-align: center;
            font-size: 14px;
            padding-top: 11px;
            @media only screen and (max-width: 576px) {
                display: none;
            }
            @media print {
                padding-top: 0px;
            }
        `,
    },
    qtyFieldContainer: {
        css: css`
            width: 12.8%;
            text-align: center;
            font-size: 14px;
            @media only screen and (max-width: 576px) {
                display: none;
            }
        `,
    },
    unitPriceContainer: {
        css: css`
            width: 9.5%;
            text-align: right;
            font-size: 14px;
            @media only screen and (max-width: 576px) {
                display: none;
            }
        `,
    },
    extPriceContainer: {
        css: css`
            width: 13.9%;
            text-align: right;
            font-size: 14px;
            font-weight: bold;
            @media only screen and (max-width: 576px) {
                display: none;
            }
        `,
    },
    manufacturerItemStyles: {
        css: css`
            width: auto;
            margin: 0 0 8px 0;
            font-size: 12px;
            color: ${ADIColors.gray4};
            @media print {
                color: ${ADIColors.black};
            }
        `,
    },
    orderLineCardImageDescriptionMobile: {
        css: css`
            display: none;
            @media only screen and (max-width: 576px) {
                display: flex;
                width: 38%;
                flex-direction: column;
                align-items: center;
            }
        `,
    },
    orderLineCardInfoMobile: {
        css: css`
            display: none;
            @media only screen and (max-width: 576px) {
                display: flex;
                width: 62%;
                flex-direction: column;
                > ${StyledButton} {
                    > ${TypographyStyle} {
                        font-size: 14px;
                        color: ${getColor("text.main")};
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        word-break: break-word;
                        line-height: 1.43;
                        font-weight: 600;
                    }
                }
            }
        `,
    },
    imgTextStyles: {
        css: css`
            font-size: 10px;
            text-align: center;
            color: ${getColor("text.main")};
            border: 1px solid ${getColor("common.border")};
            padding: 0 6px;
            height: 79px;
            width: 79px;
            align-items: center;
            justify-content: center;
            display: flex;
            overflow: hidden;
            text-overflow: ellipsis;
            @media only screen and (max-width: 576px) {
                width: 115px;
                height: 96px;
            }
            @media print {
                width: 65px;
                height: 65px;
            }
        `,
    },
    imgTextStylesMobile: {
        css: css`
            font-size: 10px;
            text-align: center;
            color: ${getColor("text.main")};
            border: 1px solid ${getColor("common.border")};
            padding: 0 6px;
            height: 79px;
            width: 79px;
            align-items: center;
            justify-content: center;
            display: flex;
            overflow: hidden;
            text-overflow: ellipsis;
            @media only screen and (max-width: 576px) {
                width: 115px;
                height: 96px;
            }
            @media print {
                display: none;
            }
        `,
    },
    productImageLink: {
        css: css`
            width: 78px;
            height: 78px;
            @media only screen and (max-width: 576px) {
                justify-content: center;
                width: 127px;
            }
            @media print {
                width: 65px;
                height: 65px;
            }
        `,
    },
    productImageLinkMobile: {
        css: css`
            @media print {
                display: none;
            }
            width: 78px;
            height: 78px;
            @media only screen and (max-width: 576px) {
                justify-content: center;
                width: 127px;
            }
        `,
    },
    orderLineCardImage: {
        css: css`
            img {
                max-width: 78px;
                max-height: 78px;
                object-fit: contain;
                width: 100%;
                @media only screen and (max-width: 576px) {
                    width: 100% !important;
                    height: auto !important;
                    object-fit: contain;
                    max-height: 96px;
                    max-width: 127px;
                }
                @media print {
                    max-width: 65px;
                    max-height: 65px;
                }
            }
        `,
    },
    orderLineCardImageMobile: {
        css: css`
            img {
                max-width: 78px;
                max-height: 78px;
                object-fit: contain;
                width: 100%;
                @media print {
                    display: none;
                }
                @media only screen and (max-width: 576px) {
                    width: 100% !important;
                    height: auto !important;
                    object-fit: contain;
                    max-height: 96px;
                    max-width: 127px;
                }
            }
        `,
    },
    orderLineCardImageDescription: {
        css: css`
            width: 54.7%;
            text-align: left;
            display: flex;
            @media only screen and (max-width: 576px) {
                display: none;
            }
        `,
    },
    ecoFeeContainerStyle: {
        css: css`            
            width: 100% !important;
            padding-left: 105px !important;
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [css` margin: 5px 0 20px 8px;
                order: 1;
                position: relative;
                left: 36%;
                padding-left: 0 !important;`,],); 
            }}
        `,
    },

};

const styles = adiRfqQuoteDetailsOrderLinesListStyles;

const ADIRfqQuoteDetailsOrderLinesList: FC<Props> = ({
    quoteDetails,
    disablingAcceptCheckout,
    isAcceptCheckoutDisable,
    setQtyItems,
    qtyItems,
    setNewQuoteDetails,
    setIsAcceptCheckoutDisable,
}) => {
    const [initState, setInitState] = useState(true);

    useEffect(() => {
        if (quoteDetails && initState) {
            const newQtyItems: any = [];
            quoteDetails?.invoiceOrderLines[0]?.invoiceOrderLines.map((item: any, index: number) =>
                newQtyItems.push({
                    ...item,
                    qtyOrdered: item.qtyShipped,
                }),
            );
            setQtyItems(newQtyItems);
            setInitState(false);
        }
    }, [quoteDetails]);

    return (
        <>
            <StyledWrapper {...styles.orderDetailsHeader}>
                <Typography {...styles.orderDetailsItemsText}>{translate("Items")}</Typography>
                {quoteDetails?.properties["projectStatus"] === "Y" && (
                    <Typography {...styles.orderDetailsAvailableQtyText}>{translate("Available Qty")}</Typography>
                )}
                <Typography {...styles.orderDetailsQtyText}>{translate("Qty")}</Typography>
                <Typography {...styles.orderDetailsUnitPriceText}>{translate("Unit Price")}</Typography>
                <Typography {...styles.orderDetailsExtPriceText}>{translate("Ext. Price")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.orderDetailsContainer}>
                {quoteDetails?.invoiceOrderLines[0]?.invoiceOrderLines.map((item: any, index: number) => (
                    <>
                        {qtyItems && quoteDetails?.invoiceOrderLines?.length > 0 && (
                            <OrderLineCard
                                item={item}
                                index={index}
                                quoteDetails={quoteDetails}
                                qtyItems={qtyItems}
                                setQtyItems={setQtyItems}
                                setNewQuoteDetails={setNewQuoteDetails}
                                disablingAcceptCheckout={disablingAcceptCheckout}
                                isAcceptCheckoutDisable={isAcceptCheckoutDisable}
                                setIsAcceptCheckoutDisable={setIsAcceptCheckoutDisable}
                            />
                        )}
                    </>
                ))}
            </StyledWrapper>
        </>
    );
};

const OrderLineCard = (props: {
    quoteDetails: OrderModel | undefined;
    index: number;
    item: any;
    qtyItems: any;
    setQtyItems: Function;
    disablingAcceptCheckout: () => void;
    isAcceptCheckoutDisable: boolean;
    setNewQuoteDetails: Function;
    setIsAcceptCheckoutDisable: Function;
}) => {
    const {
        quoteDetails,
        item,
        index,
        qtyItems,
        setQtyItems,
        disablingAcceptCheckout,
        setNewQuoteDetails,
        setIsAcceptCheckoutDisable,
    } = props;

    const projectStatus = quoteDetails?.properties["projectStatus"];
    const [errorState, setErrorState] = useState(false);
    const [changeQty, setChangeQty] = useState(0);
    
    useEffect(() => {
        if (qtyItems[index]?.qtyOrdered >= 0) {
            setChangeQty(qtyItems[index]?.qtyOrdered)
        }
    }, [qtyItems[index]?.qtyOrdered])

    const manufacturerCustomStyle = () => css`
        display: ${item?.manufacturerItem === null || item?.manufacturerItem === "" ? "none" : "inline-block"};
    `;

    const descriptionCustomStyle = () => css`
        > ${StyledButton} {
            width: 90%;
            margin: 0px 0px 5px 0px;
            &:hover {
                color: ${getColor("text.main")} !important;
                text-decoration: underline;
            }
            > ${TypographyStyle} {
                font-size: 16px;
                color: ${getColor("text.main")} !important;
                font-weight: 600;
                line-height: 22px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                &:hover {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            }
        }
    `;

    const formatAsCurrency = (num: number) => {
        return num.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        });
    };
    
    const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        let key = event.which || event.keyCode;
        if (!(key >= 48 && key <= 57))
        (event.target as any).blur();
    };    
    const updatePrice = useCallback((changeQty) => {
        let qtyEntered = changeQty;
        const newQtyItems = cloneDeep(qtyItems);
        let availQty = newQtyItems[index].qtyShipped;
        
        setErrorState(prev => false);
        
        newQtyItems[index] = {
            ...item,
            qtyOrdered: changeQty || availQty,
        };
        setQtyItems(newQtyItems);   
        
        if (qtyEntered > availQty) {
            disablingAcceptCheckout();
            setErrorState(prev => true);
        } else {
            const isErrors = newQtyItems.filter((item: any) => item.qtyOrdered > item.qtyShipped);
            if (isErrors.length > 0) {
                disablingAcceptCheckout();
            } else {
                setIsAcceptCheckoutDisable(false);
            }
            newQtyItems[index].lineTotal = newQtyItems[index].unitPrice * qtyEntered;
            let tot = 0;
            newQtyItems[index].lineTotalDisplay = formatAsCurrency(newQtyItems[index].lineTotal).toString();
            newQtyItems.forEach((ol: any) => {
                tot = (ol.lineTotal == 0 ? ol.qtyOrdered * ol.unitCost : ol.lineTotal) + tot;
            });
            const newQuoteDetail = cloneDeep(quoteDetails);

            if (newQuoteDetail) {
                newQuoteDetail.invoiceOrderLines[0].amountDisplay = formatAsCurrency(tot).toString();
                newQuoteDetail.invoiceOrderLines[0].invoiceOrderLines = newQtyItems;
                if (newQuoteDetail?.orderLines?.length) {
                    newQuoteDetail.orderLines[index].qtyOrdered = qtyEntered;
                }
            }

            setNewQuoteDetails({
                ...newQuoteDetail,
            });
            if (tot == 0) {
                disablingAcceptCheckout();
            }
        }
    }, [changeQty]);

    return (
        <StyledWrapper {...styles.orderLineCardGridContainer} key={index}>
                <StyledWrapper {...styles.orderLineCardImageDescription}>
                    {item?.properties["smallImagePath"] !== null && item?.isActiveProduct && (
                        <Link {...styles.productImageLink} href={`/product/${item?.productErpNumber}`}>
                            <LazyImage
                                {...styles.orderLineCardImage}
                                src={item?.properties["smallImagePath"]}
                                altText={item?.properties["longDescription"]}
                            />
                        </Link>
                    )}
                    {item?.properties["smallImagePath"] === null && (
                        <Link
                            {...styles.productImageLink}
                            title="Product Image Link"
                            className={`${item.properties["smallImagePath"] == null} ? 'no-image-wrapper' : ''`}
                        >
                            <Typography {...styles.imgTextStyles}>{item?.productErpNumber}</Typography>
                        </Link>
                    )}
                    {!item?.isActiveProduct && item?.properties["smallImagePath"] !== null && (
                        <Link {...styles.productImageLink} title="Product Image Link">
                            <LazyImage
                                {...styles.orderLineCardImage}
                                src={item?.properties["smallImagePath"]}
                                altText={item?.properties["longDescription"]}
                            />
                        </Link>
                    )}
                    <StyledWrapper {...styles.descriptionHeaderRight}>
                        {item?.properties["longDescription"] !== null &&
                            item?.properties["longDescription"] !== "" &&
                            item?.isActiveProduct && (
                                <Link href={`/product/${item?.productErpNumber}`}>
                                    {item?.properties["longDescription"]}
                                </Link>
                            )}

                        {item?.properties["longDescription"] !== null &&
                            item?.properties["longDescription"] !== "" &&
                            !item?.isActiveProduct && (
                                <Typography as="p" {...styles.longDescriptionStyles}>
                                    {item?.properties["longDescription"]}
                                </Typography>
                            )}

                        {(item?.properties["longDescription"] === null ||
                            item?.properties["longDescription"] === "") && (
                                <Typography as="p" {...styles.longDescriptionStyles}>
                                    {item?.description}
                                </Typography>
                            )}

                        <Typography {...styles.manufacturerItemStyles}>
                            {item?.properties["modelNumber"] != null && item?.properties["modelNumber"] != "" && (
                                <>
                                    <Typography as="span" css={manufacturerCustomStyle()}>
                                        {item?.properties["modelNumber"]}&nbsp;|&nbsp;
                                    </Typography>
                                    <Typography as="span">{item?.productErpNumber}</Typography>
                                </>
                            )}
                            {item?.properties["smallImagePath"] == null && !item?.isActiveProduct && (
                                    <Typography as="span">{item?.productErpNumber}</Typography>
                            )}
                        </Typography>

                        <Typography {...styles.totalPrint}>{item?.lineTotalDisplay}</Typography>

                        {item?.properties["nonReturnable"] === "N" && (
                            <Typography {...styles.manufacturerItemStyles}>{translate("Non-Returnable")}</Typography>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                {projectStatus === "Y" && (
                    <StyledWrapper {...styles.qtyFieldContainerAvailable}>
                        <Typography>{item?.qtyShipped}</Typography>
                    </StyledWrapper>
                )}
                <StyledWrapper {...styles.qtyFieldContainer}>
                    {qtyItems.length > 0 && projectStatus === "Y" && (
                        <StyledWrapper {...styles.inputFieldStyles}>
                            <TextField
                                value={changeQty}
                                onBlur={(e)=> {
                                    let qtyValue = e.target.value || qtyItems[index]?.qtyShipped
                                    setChangeQty(qtyValue);
                                    updatePrice(qtyValue);
                                }}
                                onKeyPress={keyPressHandler}
                                onChange={e => setChangeQty(e.target.value as any)}
                                error={errorState}
                            />
                            {errorState && (
                                <p className="error-qty-msg quote-print-only">
                                    <img
                                        title="Error Icon"
                                        src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Quotelist/error-icon.svg"
                                    />
                                    {translate("Qty cannot be more than Available Qty")}
                                </p>
                            )}
                        </StyledWrapper>
                    )}
                    {qtyItems.length > 0 && !(projectStatus === "Y") && (
                        <StyledWrapper {...styles.desktopQtyField}>
                            <Typography>{item?.qtyShipped}</Typography>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
                <StyledWrapper {...styles.unitPriceContainer}>
                {item?.properties?.itemInd == "K" && (
                    <Typography>{item?.properties?.currencySymbol}0.00</Typography>
                    )}
                    {item?.properties?.itemInd != "K" && (
                    <Typography>{item?.unitPriceDisplay}</Typography>
                    )}
                </StyledWrapper>
                <StyledWrapper {...styles.extPriceContainer}>
                    {qtyItems.length > 0 && item?.properties?.itemInd == "K" && (<Typography>{item?.properties?.currencySymbol}0.00</Typography>)}
                    {qtyItems.length > 0 && item?.properties?.itemInd != "K" && (<Typography>{qtyItems[index].lineTotalDisplay}</Typography>)}
                </StyledWrapper>
                {/* // Eco fee and Special handling implementation ----P21 Change */}
                {item?.properties?.ecoFeeDisplay != "$0.00" && (
                    <Typography as="div" {...styles.ecoFeeContainerStyle}><ADIEcoFeeDisplay extendedStyles={ADIECOFeeExtendedStyles} orderLine={item}   /> </Typography>
                )}
                {item?.properties?.specialHandlingFeeDisplay != "$0.00" && (
                    <Typography as="div" {...styles.ecoFeeContainerStyle}><ADISpecialHandlingFeeDisplay extendedStyles={ADISpecialHandlingFeeExtendedStyles} orderLine={item}   /> </Typography>
                )}
                <StyledWrapper {...styles.orderLineCardImageDescriptionMobile}>
                    {item?.properties["smallImagePath"] !== null && item?.isActiveProduct && (
                        <Link {...styles.productImageLinkMobile} href={`/product/${item?.productErpNumber}`}>
                            <LazyImage
                                {...styles.orderLineCardImageMobile}
                                src={item?.properties["smallImagePath"]}
                                altText={item?.properties["longDescription"]}
                            />
                        </Link>
                    )}
                    {item?.properties["smallImagePath"] === null && (
                        <Link
                            {...styles.productImageLinkMobile}
                            title="Product Image Link"
                            className={`${item.properties["smallImagePath"] == null} ? 'no-image-wrapper' : ''`}
                        >
                            <Typography {...styles.imgTextStylesMobile}>{item?.productErpNumber}</Typography>
                        </Link>
                    )}
                    {!item?.isActiveProduct && item?.properties["smallImagePath"] !== null && (
                        <Link {...styles.productImageLinkMobile} title="Product Image Link">
                            <LazyImage
                                {...styles.orderLineCardImageMobile}
                                src={item?.properties["smallImagePath"]}
                                altText={item?.properties["longDescription"]}
                            />
                        </Link>
                    )}
                    <StyledWrapper {...styles.manufacturerItemContainerMobileStyles}>
                        <Typography {...styles.manufacturerItemMobileStyles}>
                            {item?.properties["modelNumber"] !== null && item?.properties["modelNumber"] !== "" && (
                                <>
                                    <Typography as="p" css={manufacturerCustomStyle()}>
                                        {item?.properties["modelNumber"]}
                                    </Typography>
                                    <Typography as="p">{item?.productErpNumber}</Typography>
                                </>
                            )}
                            {item?.properties["smallImagePath"] == null && !item?.isActiveProduct && (
                                    <Typography as="span">{item?.productErpNumber}</Typography>
                            )}
                        </Typography>
                        {item.properties["nonReturnable"] === "N" && (
                            <Typography {...styles.manufacturerItemMobileStyles}>
                                {translate("Non-Returnable")}
                            </Typography>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.orderLineCardInfoMobile}>
                    {item?.properties["longDescription"] !== null &&
                        item?.properties["longDescription"] !== "" &&
                        item?.isActiveProduct && (
                            <Link
                                {...styles.productDescriptionStylesMobile}
                                href={`/product/${item?.productErpNumber}`}
                                css={descriptionCustomStyle()}
                            >
                                {item?.properties["longDescription"]}
                            </Link>
                        )}

                    {item?.properties["longDescription"] !== null &&
                        item?.properties["longDescription"] !== "" &&
                        !item?.isActiveProduct && (
                            <Typography as="p" {...styles.longDescriptionMobileStyles}>
                                {item?.properties["longDescription"]}
                            </Typography>
                        )}

                    {(item?.properties["longDescription"] === null || item?.properties["longDescription"] === "") && (
                        <Typography as="p" {...styles.longDescriptionMobileStyles}>
                            {item?.description}
                        </Typography>
                    )}
                    {item?.properties?.itemInd != "K" && ( 
                    <Typography as="p" {...styles.extPriceMobileStyles}>
                    {item?.lineTotalDisplay}
                    </Typography>
                    )}
                    {item?.properties?.itemInd == "K" && ( 
                    <Typography as="p" {...styles.extPriceMobileStyles}>
                    {item?.properties?.currencySymbol}0.00
                    </Typography>
                    )}
                    <StyledWrapper {...styles.unitPriceMobileStyles}>
                        <Typography>{translate("(Unit Price:")}&nbsp;</Typography>
                        {item?.properties?.itemInd == "K" && (
                    <Typography>{`${item?.properties?.currencySymbol}0.00)`}</Typography>
                    )}
                    {item?.properties?.itemInd != "K" && (
                        <Typography>{`${item?.unitPriceDisplay})`}</Typography>)}
                    </StyledWrapper>

                    {projectStatus === "Y" && (
                        <StyledWrapper {...styles.availableQtyFieldMobile}>
                            <Typography>{translate("Available Qty:")}&nbsp;</Typography>
                            <Typography>{item?.qtyShipped}</Typography>
                        </StyledWrapper>
                    )}
                    <StyledWrapper {...styles.qtyMobileStyles}>
                        {qtyItems.length > 0 && projectStatus === "Y" && (
                            <StyledWrapper {...styles.inputFieldStyles}>
                                <TextField
                                    value={changeQty}
                                    onBlur={(e)=> {
                                        let qtyValue = e.target.value || qtyItems[index]?.qtyShipped
                                        setChangeQty(qtyValue);
                                        updatePrice(qtyValue);
                                    }}
                                    onKeyPress={keyPressHandler}
                                    onChange={e => setChangeQty(e.target.value as any)}
                                    error={errorState}
                                />
                                {errorState && (
                                    <p className="error-qty-msg quote-print-only">
                                        <img
                                            title="Error Icon"
                                            src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Quotelist/error-icon.svg"
                                        />
                                        {translate("Qty cannot be more than Available Qty")}
                                    </p>
                                )}
                            </StyledWrapper>
                        )}
                        {qtyItems.length > 0 && !(projectStatus === "Y") && (
                            <StyledWrapper {...styles.availableQtyFieldMobile}>
                                <Typography>{translate("Available Qty:")}&nbsp;</Typography>
                                <Typography>{item?.qtyShipped}</Typography>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
        </StyledWrapper>
    );
};

export default ADIRfqQuoteDetailsOrderLinesList;
